import options from './on-visible.directive';

export default {
    selector: 'onVisible',
    options
};
